import aaronProfile from "../../assets/images/landing/aaronprofile.png";
import jyProfile from "../../assets/images/landing/jyprofile.png";
import jyProfile2 from "../../assets/images/landing/jyprofile2.png";
import jyBackground from "../../assets/images/landing/jyhike.png";
import aaronBackground from "../../assets/images/landing/aaronbg.png";
import seohuiProfile from "../../assets/images/landing/seohui.png";
import aaronProfile2 from "../../assets/images/landing/aaronProfile2.png";

const contributorsData = [
  {
    image: aaronProfile,
    profileImage: aaronProfile2,
    backgroundImage: aaronBackground,
    name: "Aaron Kao",
    description: "Driving Developer",
    profileDescription: `Aaron is the lead developer of this app. He graduated with a degree in Mechanical Engineering but decided to follow his passion to become a Software Engineer. He has previously worked at Sony, getting credited on major films such as Angry Birds 2, spent 2 years doing development work on the TELUS customer-facing website, and working as is a Software Engineer at Alida. Currently, he is working as a Software Engineer at Autodesk as part of the Connected Delivery team.<br /><br />Outside of work, Aaron’s main hobbies include playing sports, such as badminton, pickleball, DDR, and basketball, as well as watching Anime and playing video games.`,
    ethnicity: "Chinese",
    linkedIn: "https://www.linkedin.com/in/aaron-kao",
  },
  {
    image: jyProfile,
    profileImage: jyProfile2,
    backgroundImage: jyBackground,
    name: "Jiyoung Lim",
    description: "Developer",
    profileDescription: `Jiyoung graduated with a Software Engineering degree from Pusan National University. She was previously a web developer at a law firm, and is currently a Software Engineer working on the core surveys team at Alida. She is extremely active in the community, writing tech articles, working on various side projects, and acting as an executive for toastmasters.
    
    Outside of work, Jiyoung’s main hobbies include playing sports, such as badminton, pickleball, DDR, and basketball, as well as reading Manga, and exploring new food.`,
    ethnicity: "Korean",
    linkedIn: "https://www.linkedin.com/in/g0lim",
  },
  {
    image: seohuiProfile,
    profileImage: seohuiProfile,
    backgroundImage: seohuiProfile,
    name: "Seohui Nam",
    profileDescription:
      "Sally is working on various side projects and loves food and Anime.",
    description: "Designer",
    ethnicity: "Korean",
  },
];

export default contributorsData;
